import { requirePermission } from "@lib/permissions/guards";
import { PERMISSIONS } from "@lib/permissions/permissions.generated";
import { createFileRoute } from "@tanstack/react-router";
import { Plus } from "lucide-react";
import NoteDeFraisForm from "@/features/rh/notes-de-frais/components/NoteDeFraisForm";

export const Route = createFileRoute("/_app/(dashboard)/frais/create")({
  loader: requirePermission(PERMISSIONS.RH.FRAIS.VIEW),
  staticData: {
    title: "Nouvelle note de frais",
    icon: Plus,
    permission: PERMISSIONS.RH.FRAIS.VIEW,
    section: "App",
    showInBreadcrumb: true,
  },
  component: () => <NoteDeFraisForm backTo="/frais/me" autoPersonne hidePersonne />,
});
